<template>
  <div
    v-if="showDate"
    class="dates-and-times"
  >
    <span
      v-if="publishedDate"
      class="published-at"
      data-testid="published-date"
    >
      {{ publishedLabel }}: {{ formattedPublishedDate }}
    </span>
    <span
      v-if="updatedDate && publishedDate !== updatedDate"
      class="updated-at"
      data-testid="updated-date"
    >
      {{ updatedLabel }}: {{ formattedUpdatedDate }}
    </span>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { monthDayYear } from '@/helpers/date-utils';

const props = defineProps({
  searchResult: {
    type: Object,
    required: true,
  },
});

const { $t } = useNuxtApp();

const datePropMap = computed(() => {
  switch (props.searchResult.type) {
    case 'form':
    case 'article': {
      return { published: 'publish_date', updated: 'updated_at' };
    }
    case 'scores_schedule':
    case 'event':
    case 'public_file':
    case 'documents_asset':
    case 'directory':
      return { published: 'created_at', updated: 'updated_at' };
    default:
      return { published: 'published_at', updated: 'updated_at' };
  }
});

const publishedDate = computed(() => {
  return props.searchResult[datePropMap.value.published];
});
const updatedDate = computed(() => {
  return props.searchResult[datePropMap.value.updated];
});

const formattedPublishedDate = computed(() => {
  return publishedDate.value ? monthDayYear(publishedDate.value) : '';
});
const formattedUpdatedDate = computed(() => {
  return updatedDate.value ? monthDayYear(updatedDate.value) : '';
});

const showDate = computed(() => publishedDate.value || updatedDate.value);

const publishedLabel = computed(() => {
  return $t('search.forms.published');
});
const updatedLabel = computed(() => {
  return $t('search.forms.updated');
});
</script>

<style lang="scss" scoped>
@use '@/components/global/scss/mixins/_breakpoints.scss' as bp;

.dates-and-times {
  display: flex;
  gap: 12px;
  color: var(--color-text-secondary);
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0.1px;
}

@include bp.screen('xs') {
  .dates-and-times {
    gap: 4px;
    flex-direction: column;
  }
}
</style>
